var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_801)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.32905L11.9518 0.402344V37.671L0 43.5977V6.32905ZM28.0517 6.32905L40 0.402344V37.671L28.0517 43.5977V6.32905ZM25.9742 6.32905L14.0258 0.402344V37.671L25.9742 43.5977V6.32905Z",
    fill: "#FF9966"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 43.1954,
    fill: "white",
    transform: "translate(0 0.402344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsIcon);
export default __webpack_public_path__ + "static/media/maps-icon.28158570685387066da714fc6456fe89.svg";
export { ForwardRef as ReactComponent };